import React from "react";
import "./StarRating.scss";
import IconViewer from "../../Assets/svg/IconViewer";

const StarRating = ({ rating }) => {

  const floorRating = Math.floor(rating);
  const isHalfStar = rating % 1 !== 0;

  return (
    <div className="starRatingBox__">
      {[1, 2, 3, 4, 5].map((star) => {
        return (
          <span key={star} className="star">
            {star <= floorRating ? <IconViewer icon={"FullStarIcon"} /> : null}
            {isHalfStar && star === floorRating ? (
              <IconViewer icon={"HalfStarIcon"} />
            ) : null}
            {!isHalfStar && star > floorRating  ? (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="14"
                height="14"
                viewBox="0 0 14 14"
                fill="none"
              >
                <path
                  d="M7.42096 0.350034L9.08096 3.70003C9.13044 3.78327 9.19872 3.85375 9.28034 3.90585C9.36195 3.95795 9.45464 3.9902 9.55096 4.00003L13.251 4.54003C13.3559 4.56092 13.4535 4.60905 13.534 4.6796C13.6145 4.75014 13.675 4.84062 13.7095 4.94195C13.7439 5.04327 13.7511 5.15188 13.7303 5.25686C13.7095 5.36184 13.6614 5.4595 13.591 5.54003L10.961 8.24003C10.8912 8.31201 10.8387 8.39895 10.8075 8.49425C10.7763 8.58955 10.7672 8.69071 10.781 8.79003L11.421 12.48C11.4398 12.5938 11.4265 12.7106 11.3825 12.8173C11.3386 12.9239 11.2658 13.0162 11.1723 13.0838C11.0788 13.1513 10.9683 13.1914 10.8532 13.1996C10.7381 13.2078 10.6231 13.1837 10.521 13.13L7.16096 11.39C7.07067 11.3459 6.97148 11.3229 6.87096 11.3229C6.77045 11.3229 6.67126 11.3459 6.58096 11.39L3.27096 13.13C3.16884 13.1837 3.05379 13.2078 2.93873 13.1996C2.82367 13.1914 2.71317 13.1513 2.61966 13.0838C2.52615 13.0162 2.45333 12.9239 2.4094 12.8173C2.36546 12.7106 2.35215 12.5938 2.37096 12.48L2.96096 8.79003C2.97837 8.69144 2.97202 8.59013 2.94246 8.49448C2.91289 8.39883 2.86096 8.31161 2.79096 8.24003L0.150963 5.63003C0.080482 5.5495 0.0324297 5.45184 0.0116307 5.34686C-0.00916824 5.24188 -0.00198171 5.13327 0.0324687 5.03195C0.0669191 4.93062 0.127421 4.84014 0.207899 4.7696C0.288377 4.69905 0.385999 4.65092 0.490963 4.63003L4.19096 4.00003C4.28686 3.98872 4.37896 3.95586 4.46035 3.90391C4.54175 3.85195 4.61033 3.78226 4.66096 3.70003L6.31096 0.350034C6.35951 0.243591 6.43764 0.153355 6.53605 0.0900805C6.63445 0.0268063 6.74897 -0.00683594 6.86596 -0.00683594C6.98295 -0.00683594 7.09748 0.0268063 7.19588 0.0900805C7.29428 0.153355 7.37242 0.243591 7.42096 0.350034Z"
                  fill="#DADADA"
                />
              </svg>
            ) : null }
          </span>
        );
      })}
    </div>
  );
};

export default StarRating;
